<template>
  <div class="px-4 sm:px-6 lg:px-8">

    <div class=" w-full  flex justify-between items-center">
      <div class="">
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
        <!-- <button @click="getList()" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">查询</button> -->
      </div>
      <a href="javascript:;" type="button" @click="withdrawal" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto cursor-pointer">提现账户设置</a>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">提现金额</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">申请时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">完成时间</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">￥{{item.WithdrawalAmount}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500" :title="item.Remark">
                    <span v-if="item.Status === 4" class="text-green-600">已打款</span>
                    <span v-else-if="item.Status === 3" class="text-cyan-300">待打款</span>
                    <span v-else-if="item.Status === 2" class="text-cyan-300">待提现</span>
                    <span v-else-if="item.Status === 1" class="text-cyan-300">待审核</span>
                    <span v-else-if="item.Status === 0" class="text-cyan-300">已申请</span>
                    <span v-else-if="item.Status === -1" class="text-[#f00]">无效</span>
                    <span v-else-if="item.Status === -2" class="text-[#f00]">无效</span>
                    <span class="text-red" v-else>--</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.CompleteTime === '0001-01-01 00:00:00' ? '--' : item.CompleteTime}}</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="view(item)" title="关联产品记录">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="versionDialog" title="" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2"></div>
    </Modal>
    <Modal :visible.sync="detailDialog" title="关联推广订单列表" :ActionBtnShow="false" width="max-w-5xl">
      <table class="min-w-full divide-y divide-gray-300" v-if="detail && detail.Rebates && detail.Rebates.length">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">订单号</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">用户名</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">实付金额</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">佣金金额</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">佣金比例</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="item in detail.Rebates" :key="item.Key">
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.OrderNo}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.OrderUser.nick_name || item.OrderUser.user_name}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">￥{{item.OrderRealAmount}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">￥{{item.RebateAmount}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{parseInt(item.RebateRatio * 100)}}%</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
          </tr>
        </tbody>
      </table>
    </Modal>
    <Modal :visible.sync="configDialog" title="提现账户设置" :ActionBtnShow="true" @submit="submitConfig()" width="max-w-xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4">
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-1">提现方式</label>
          </div>
          <div class="sm:col-span-3">
            <input type="text" value="支付宝" disabled class="block sm:w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-gray-200">
            <!-- <input v-model="withdrawalForm.withdrawal_bank_name" type="text" autocomplete="off" name="project-name" class="block sm:w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"> -->
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">支付宝姓名</label>
          </div>
          <div class="sm:col-span-3">
            <input v-model="withdrawalForm.withdrawal_account_name" type="text" autocomplete="off" name="project-name" class="block sm:w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">支付宝账号</label>
          </div>
          <div class="sm:col-span-3">
            <input v-model="withdrawalForm.withdrawal_account_number" type="text" autocomplete="off" name="project-name" class="block sm:w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination.vue'
import Alert from '../../components/Alert.vue'
import Notify from '../../components/Notification.vue'
import { pageRebateWithdrawalList as pageList, removeRebateList as remove, withdrawalConfig, withdrawalConfigUpdate } from '../../api/Rebate'
import { debounce } from 'lodash'
import Modal from '../../components/Modal.vue'
export default {
  name: 'ScoreList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        Keyword: '',
        Sort: '-id'
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      user: { score: 0 },
      detail: {},
      detailDialog: false,
      configDialog: false,
      withdrawalForm: {
        withdrawal_account_type: 0,
        withdrawal_bank_name: '',
        withdrawal_account_name: '',
        withdrawal_account_number: ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    withdrawal () {
      withdrawalConfig().then((res) => {
        this.withdrawalForm = {
          withdrawal_account_type: 0,
          withdrawal_bank_name: '支付宝',
          withdrawal_account_name: res.data.data.withdrawal_account_name,
          withdrawal_account_number: res.data.data.withdrawal_account_number
        }
        this.configDialog = true
      })
    },
    submitConfig () {
      withdrawalConfigUpdate(this.withdrawalForm).then(() => {
        this.notifyShow({ title: '提交成功' })
        this.configDialog = false
      })
    },
    view (detail) {
      this.detail = detail
      this.detailDialog = true
    },
    deleteItem (key) {
      this.alertShow = true
      this.alterMsg = undefined
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(key).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
